import { render, staticRenderFns } from "./ReturnDialog.vue?vue&type=template&id=32b6f634&scoped=true&"
import script from "./ReturnDialog.vue?vue&type=script&lang=ts&"
export * from "./ReturnDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnDialog.vue?vue&type=style&index=0&id=32b6f634&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b6f634",
  null
  
)

export default component.exports